module.exports = __webpack_public_path__ + "img/trained.5b0effc4.png";